'use strict';

const inspectableError = require('../rlink-inspectable-error');

function getPrimitive (obj, onNotPrimitive = obj => Object(obj).valueOf() ) {
  if (typeof obj === 'object') {
    if (Symbol.toPrimitive in obj) {
      return obj[Symbol.toPrimitive]('default');
    } else {
      return onNotPrimitive(obj);
    }
  } else {
    return obj;
  }
}

getPrimitive.orAssert = function getPrimitiveOrAssert (obj) {
  return getPrimitive(obj, object => {
    throw inspectableError`${{object}} is not a wrapper for a primitive value`;
  });
};

module.exports = getPrimitive;



// WEBPACK FOOTER //
// ./lib/rlink-type-utils/getPrimitive.js